import styled from 'styled-components';

export const LoginContainer = styled.div`
  min-width: 320px;
  max-width: 400px;
  height: auto;
  position: absolute;
  top: 20%;
  left: 0;
  right: 0;
  margin: auto;
  border: 1px solid #cccccc;
`;

export const MPaper = styled.div`
  padding: 50px 20px 20px 20px;
  overflow: auto;
`;



// WEBPACK FOOTER //
// ./src/views/Login/styles.js